export function noticeError(error: any) {
  if (window.newrelic) {
    window.newrelic.noticeError(error);
  }
}
